import { render, staticRenderFns } from "./SetupPopup.vue?vue&type=template&id=36a121e1&scoped=true&"
import script from "./SetupPopup.vue?vue&type=script&lang=js&"
export * from "./SetupPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a121e1",
  null
  
)

export default component.exports